module.exports = __webpack_public_path__ + "static/media/layer-3@3x.9ae368b2.png";